import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const GET_ALL_QUOTATIONS_COUNTER = "GET_ALL_QUOTATIONS_COUNTER";
export const GET_ALL_QUOTATIONS_COUNTER_LOADING =
"GET_ALL_QUOTATIONS_COUNTER_LOADING";
export const GET_ALL_QUOTATIONS_COUNTER_LOADING_FAILED =
"GET_ALL_QUOTATIONS_COUNTER_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const quotationCounterLoading = ms => ({
    type: GET_ALL_QUOTATIONS_COUNTER_LOADING,
    payload: ms
    });
    
    export const quotationCounterLoadingFailed = ms => ({
    type: GET_ALL_QUOTATIONS_COUNTER_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function quotationCounter() {
  /* ${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/getCountOfQuotation  */
    const request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/getCountOfQuotation`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });

    return dispatch => {

    dispatch(quotationCounterLoading());
 
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200) {
     console.log(response,"response quotationCounter")
    dispatch({
    type: GET_ALL_QUOTATIONS_COUNTER,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        quotationCounterLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(quotationCounterLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(quotationCounterLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(quotationCounterLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


